import { render, staticRenderFns } from "./RagioneriaBarView.vue?vue&type=template&id=73920b21&"
import script from "./RagioneriaBarView.vue?vue&type=script&lang=ts&"
export * from "./RagioneriaBarView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports